<div class="mct-flex mct-col mct-gap-27"   *ngIf="socialMediaData">
  <div class="mct-flex mct-col mct-gap-5"  >
    <label> {{ 'form-builder.legos.social-media' | translate | ucfirst }} </label>
    <p-select
      name="socialMediaId"
      appendTo="body"
      [style]="{ width: '100%' }"
      [options]="socialMedias"
      [(ngModel)]="socialMediaData.SocialMediaTypeId"
      (onChange)="socialMediaChanged($event.value)"
      [placeholder]="'common.select-one' | translate | ucfirst"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-gap-5"  >
    <label> {{ 'form-builder.legos.display-name' | translate | ucfirst }} </label>
    <input name="socialMediaLabel" class="form-control" [(ngModel)]="socialMediaData.Label" />
  </div>
</div>
